import { tt, type HubTab } from '@agos/shared'

/**
 * *Správa rozvozu → Nastavenia rozvozu*, as tabs - FRONTEND.md §9.302.
 *
 * The owner: *"in Správa Rozvoz - Nastavenia Rozvozu, add more settings.. one for that QR code
 * payment settings, if its already somewhere, movve it there"*. It was somewhere - `/qr-payment`,
 * its own sidebar entry under a different section - so this is the move.
 *
 * **The guards are the folded sidebar entries' own**, asserted equal to them in the test beside this
 * file. That is the invariant worth holding for a fold: *a tab shows to exactly whoever the sidebar
 * entry it replaced showed to.* Both entries carried a tier gate as well as a permission -
 * `delivery_settings` and `qr_payment` are modules as well as flags - and matching the routes alone
 * would have widened who sees each screen, because neither route carries its tier gate.
 *
 * **Two permissions, not one, which is why the hub route had to widen.** `delivery_settings` and
 * `qr_payment` are separate flags and nothing grants them together by rule. A hub gated on
 * `delivery_settings` alone would refuse the route to somebody holding only `qr_payment` while the
 * folded sidebar entry still offered it - FB-001's exact shape. So `/delivery-settings` carries
 * `anyPermission` of the two, each tab keeps its own gate, and an employee sees precisely the tabs
 * they may see. §9.208 settled this pattern for `/settings`; this follows it.
 *
 * **One residual case, stated rather than hidden.** The hub route cannot express *(permission AND
 * module) OR (permission AND module)* - the guard shape has no such form - so it gates on the two
 * permissions only. A franchise holding both permissions with **both** modules switched off
 * therefore reaches the hub and gets its empty state instead of a refusal. That is what the empty
 * state is for, and the alternative was either a second sidebar entry (which is what the owner asked
 * to remove) or a new guard grammar for one screen.
 */
export const DELIVERY_TABS: readonly HubTab[] = [
  {
    // The depot address, which was the whole of this screen before the move. First because it is
    // what somebody opening *Nastavenia rozvozu* came for.
    id: 'depot',
    label: tt('Depot'),
    path: '/delivery-settings',
    guard: { permission: 'delivery_settings', franchiseModule: 'delivery_settings' },
  },
  {
    id: 'qr',
    label: tt('QR platba'),
    path: '/qr-payment',
    guard: { permission: 'qr_payment', franchiseModule: 'qr_payment' },
  },
]
